// extracted by mini-css-extract-plugin
export default {"loginWrapper":"LoginFullPage_loginWrapper__NemNw"};